import styles from "./AdminTab.module.css";
import PropTypes from "prop-types";
import { useState } from "react";
import SearchUsersModal from "../SearchUsersModal";
import Card from "../Card";
import AdminsList from "../AdminsList";
import AddAdminModal from "../AddAdminModal";
import RemoveAdminModal from "../RemoveAdminModal";

/**
 *
 * contents under the tab bar of the admin tab of the group page
 *
 */

export function AdminTab({}) {
  const [addAdminModalOpen, setAddAdminModalOpen] = useState(false);
  const [removeAdminModalOpen, setRemoveAdminModalOpen] = useState(false);
  const [removeAdminInfo, setRemoveAdminInfo] = useState(null);

  const [searchUsersModalOpen, setSearchUsersModalOpen] = useState(false);

  var placeholderAdmins = [
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Bob",
      iboNum: "000000",
      accessLevel: "Group",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198626",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
    {
      adminName: "Albus And Minerva Mcgongall Diamondship",
      iboNum: "1516198622",
      accessLevel: "Group / Global",
    },
  ];

  function clickRemove(adminInfo) {
    setRemoveAdminInfo(adminInfo);
    setRemoveAdminModalOpen(true);
  }

  function removeAdmin() {
    // TODO: call API method here
    alert("remove called: " + JSON.stringify(removeAdminInfo));
    setRemoveAdminModalOpen(false);
  }

  function clickSearchFromAddModal() {
    setAddAdminModalOpen(false);
    setSearchUsersModalOpen(true);
  }

  function closeSearchUsersModal() {
    setSearchUsersModalOpen(false);
    setAddAdminModalOpen(true);
  }

  function addUserFromSearchModal(e) {
    alert("add admin from search modal return with admin ibo number: " + e);
    setSearchUsersModalOpen(false);
  }

  function createAdminFromAddAdminModal(e) {
    alert("onClick called with: " + e);
    setAddAdminModalOpen(false);
  }

  return (
    <div className={styles.container}>
      <Card
        title="ADMIN"
        buttonName="ADD NEW ADMIN"
        onClick={() => {
          setAddAdminModalOpen(true);
        }}
        children={
          <div className={styles.listContainer}>
            {<AdminsList admins={placeholderAdmins} onClick={clickRemove} />}
          </div>
        }
      />

      <AddAdminModal
        isOpen={addAdminModalOpen}
        onClose={() => setAddAdminModalOpen(false)}
        onClick={createAdminFromAddAdminModal}
        onSearch={(e) => clickSearchFromAddModal(e)}
      />

      <RemoveAdminModal
        isOpen={removeAdminModalOpen}
        onClose={() => setRemoveAdminModalOpen(false)}
        onClick={() => removeAdmin()}
        adminInfo={removeAdminInfo}
      />

      <SearchUsersModal
        isOpen={searchUsersModalOpen}
        onClose={() => closeSearchUsersModal()}
        onClick={addUserFromSearchModal}
        iboInfos={placeholderAdmins}
      />
    </div>
  );
}

AdminTab.propTypes = {};
